import { createFileRoute, notFound } from "@tanstack/react-router";

import { deviceModelFilesQueries } from "@/api/resources/deviceModelFiles/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import KnowledgeHubFilePage from "@/components/KnowledgeHubFiles/KnowledgeHubFilePage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/knowledge-hub/files/$file_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: `${i18n.t("navigation.knowledge-hub")} - ${i18n.t("files")}`,
        icon: <Icon.KNOWLEDGE_HUB />,
        path: "/workspaces/$workspace_id/knowledge-hub/files",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, file_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentDeviceModelFile = await context.queryClient.ensureQueryData(deviceModelFilesQueries.byId(file_id));
    if (!currentDeviceModelFile) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [
      { label: currentDeviceModelFile.title ?? i18n.t("file"), icon: <Icon.FILE_PREVIEW /> },
    ];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);

    return currentDeviceModelFile;
  },
  component: KnowledgeHubFilePage,
});
